import React, { useState } from 'react'

function TemplateFormInfoModal() {
    const [open, setOpen] = useState(false)

    const openModal = () => {
        setOpen(true)
    }

    const cancel = () => {
        setOpen(false)
    }

  return (
    <div>
        <div className="row">
            <div className="col-md-12">
                <div className="form-group">
                <label className="info-position" onClick={openModal}>
                    <span>Click for template instructions </span><i className="fas fa-question-circle ml-2 text-secondary-icon cursor-cu"></i>
                </label>
                </div>
            </div>
        </div>

         {open &&
            <div className="align-content-center align-items-center animated d-flex fadeIn h-100 justify-content-center position-fixed w-100 line-item-modal">
                <div className="bg-white mx-auto rounded shadow p-5 text-center">
                <div>
                    <h5><strong>How To Use Variables In Templates</strong></h5>
                    <div>
                        <p className="cu-template-info">
                            Variables are very powerful shortcuts that allow you to personalize posts for each individual in an audience without<br/>
                            having to create multiple posts. To use template variables in your template <i>type two curly braces {'"{{"'}<br/>
                            in either of the post's text fields and select the variable you wish to use in your content.</i>
                        </p>
                        <p className="cu-template-info">
                            <i><b>NOTE:</b> Variables in your templates will be used in the post if you choose to use that template. This works the <br/>
                            same as manually entering them in the post form when writing a post. Specific viewers will see specific information relevant to them.</i>
                        </p>
                    </div>
                </div>

                    <div className="pt-3">
                        <button onClick={cancel} type="button" className="btn btn-primary mr-2">
                            Close
                        </button>
                    </div>
                </div>
         </div>}
    </div>
  )
}

export default TemplateFormInfoModal